
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoganpatipule() {



    const cardData =
    {
        keyword: 'Pune To Ganpatipule Cab Booking',
        heading: 'Mauli Cabs:  Pune To Ganpatipule Cab Booking',
        headingDescription: 'Mauli Cabs offers smooth and reliable Pune to Ganpatipule cab booking services, making your coastal journey comfortable and enjoyable. Whether you are traveling for a relaxing beach vacation, a family trip, or a spiritual visit, we provide a variety of vehicles including sedans, SUVs, and premium cars. With professional drivers, transparent pricing, no hidden charges, and a commitment to safety, Mauli Cabs ensures a pleasant and worry-free ride from Pune to Ganpatipule.',

        top: 'Top Places to Visit in Ganpatipule with Mauli Cabs',

"topPlaces": [
    {
        "title": "Ganpatipule Temple",
        "description": "The Swayambhu Ganpati Temple is a centuries-old shrine where the idol of Lord Ganesha is believed to have self-manifested. Located right on the beach, it is a major pilgrimage destination offering a serene and spiritual experience."
    },
    {
        "title": "Ganpatipule Beach",
        "description": "Ganpatipule Beach is known for its clean sands, clear waters, and peaceful ambiance. It's perfect for leisurely walks, watching sunsets, and enjoying the natural beauty of the Konkan coast."
    },
    {
        "title": "Prachin Konkan Museum",
        "description": "The Prachin Konkan Museum is an open-air museum showcasing the traditional lifestyle, culture, and history of the Konkan region. It’s an educational and interesting stop for families and history enthusiasts."
    },
    {
        "title": "Aare Ware Beach",
        "description": "Located a few kilometers from Ganpatipule, Aare Ware Beach is a hidden gem offering long stretches of untouched sand and stunning ocean views. It's ideal for solitude seekers and photographers."
    },
    {
        "title": "Jaigad Fort",
        "description": "Jaigad Fort is a historic sea fort located at the tip of a peninsula overlooking the Arabian Sea. The fort offers panoramic views of the surroundings and insights into Maratha history and architecture."
    },
    {
        "title": "Jaigad Lighthouse",
        "description": "Near Jaigad Fort, the Jaigad Lighthouse offers sweeping views of the sea and coastline. Climbing to the top provides a unique perspective of the beautiful Konkan landscape."
    },
    {
        "title": "Malgund Village",
        "description": "Malgund is the birthplace of the famous Marathi poet Kavi Keshavsut. Visitors can explore his memorial and the quaint village setting to experience the cultural charm of the region."
    },
    {
        "title": "Hedvi Ganesh Temple",
        "description": "Located about 35 km from Ganpatipule, Hedvi Temple houses a grand idol of Lord Ganesha and is known for the natural phenomena called Bahman Ghal, where waves create a spectacular spout from rocks."
    },
    {
        "title": "Velneshwar Beach and Temple",
        "description": "A peaceful beach near an ancient Shiva temple, Velneshwar is perfect for swimming and relaxing. The serene environment makes it a great spot for a quiet day out."
    },
    {
        "title": "Thibaw Palace, Ratnagiri",
        "description": "Located about an hour’s drive from Ganpatipule, Thibaw Palace was the residence of the exiled king and queen of Burma. It offers a glimpse into colonial-era architecture and history."
    }
],

"services": [
    {
        "name": "Pune to Ganpatipule Cab Service",
        "description": "Mauli Cabs offers dependable cab services from Pune to Ganpatipule. Enjoy a scenic coastal drive with our experienced drivers and well-maintained vehicles."
    },
    {
        "name": "Book Pune to Ganpatipule Taxi",
        "description": "Book your taxi from Pune to Ganpatipule with Mauli Cabs for a convenient and relaxed travel experience. Easy booking, reliable service, and comfortable rides guaranteed."
    },
    {
        "name": "Affordable Pune to Ganpatipule Cab",
        "description": "Looking for a budget-friendly cab to Ganpatipule? Mauli Cabs offers affordable taxi options that combine comfort, safety, and value for money."
    },
    {
        "name": "Private Taxi for Ganpatipule from Pune",
        "description": "Mauli Cabs provides private taxi services from Pune to Ganpatipule for those seeking a quiet, comfortable, and flexible travel experience."
    },
    {
        "name": "Ganpatipule Trip by Cab from Pune",
        "description": "Plan your trip to the serene Ganpatipule beach with Mauli Cabs. Our taxi services ensure a smooth, safe, and scenic journey from Pune."
    },
    {
        "name": "Pune to Ganpatipule One-Way or Round Trip",
        "description": "Whether you're planning a one-way ride or a round trip, Mauli Cabs offers flexible cab services from Pune to Ganpatipule to suit your travel needs."
    },
    {
        "name": "Ganpatipule Sightseeing by Cab",
        "description": "Explore the temples and beaches of Ganpatipule with Mauli Cabs' local sightseeing taxi services. Ideal for relaxed and personalized touring experiences."
    },
    {
        "name": "Group Travel to Ganpatipule from Pune",
        "description": "Traveling with a group? Mauli Cabs offers spacious and comfortable vehicles perfect for group journeys to Ganpatipule from Pune."
    },
    {
        "name": "Comfortable Taxi Ride to Ganpatipule",
        "description": "Enjoy a smooth and comfortable taxi ride to Ganpatipule with Mauli Cabs. Our vehicles are well-equipped for long-distance coastal travel."
    },
    {
        "name": "Luxury Cab for Ganpatipule Trip",
        "description": "Travel in luxury to Ganpatipule from Pune with Mauli Cabs. Our high-end vehicles provide the perfect blend of comfort and class for your coastal getaway."
    }
],

"tableData": [
    ["Pune to Ganpatipule Cab Service", "Book Pune to Ganpatipule Taxi"],
    ["Affordable Pune to Ganpatipule Cab", "Private Taxi for Ganpatipule from Pune"],
    ["Ganpatipule Trip by Cab from Pune", "Pune to Ganpatipule One-Way or Round Trip"],
    ["Ganpatipule Sightseeing by Cab", "Group Travel to Ganpatipule from Pune"],
    ["Comfortable Taxi Ride to Ganpatipule", "Luxury Cab for Ganpatipule Trip"]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs ensures that your Pune to Ganpatipule Cab Booking is reliable and timely. Whether you're traveling for a religious visit or a peaceful getaway, our drivers guarantee punctual pickups and drop-offs, helping you reach Ganpatipule safely and on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a wide range of vehicles for your Pune to Ganpatipule trip, from sedans to SUVs and premium cars. Each vehicle is designed with air conditioning, ample legroom, and spacious interiors to ensure a comfortable ride throughout the journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the Pune to Ganpatipule route, ensuring a smooth, safe, and comfortable journey. With knowledge of the best roads and traffic conditions, they make your trip hassle-free and enjoyable."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Ganpatipule Cab Booking. With no hidden charges, you can rest assured that you're receiving a fair and competitive price for your journey."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are regularly serviced and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers adhere to strict safety protocols, ensuring a secure and comfortable ride to Ganpatipule."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Ganpatipule Cab Booking. Whether you need an early morning pickup or a late-night return, our customer service team is always ready to assist you with your booking needs."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Ganpatipule cab with Mauli Cabs is quick and easy. You can book online via our website or mobile app, or contact our customer service team for personalized assistance with your reservation."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling with family, friends, or solo, Mauli Cabs offers customized travel packages for your Pune to Ganpatipule Cab Booking. Share your preferences, and we’ll tailor your journey to suit your needs and ensure a memorable trip."
    }
]









    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Ganpatipule with Mauli Cabs?',
            answer: 'Booking your cab is simple! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Ganpatipule as your destination, then choose the vehicle that fits your needs. Alternatively, you can contact our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Ganpatipule?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that fits your comfort and space requirements for the scenic drive to Ganpatipule.',
        },
        {
            question: 'Is the fare from Pune to Ganpatipule fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. You will know the total fare upfront, with no hidden costs.',
        },
        {
            question: 'Can I book a round trip from Pune to Ganpatipule?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we’ll handle the rest.',
        },
        {
            question: 'How long does the journey from Pune to Ganpatipule take?',
            answer: 'The ride from Pune to Ganpatipule typically takes around 5 to 6 hours, depending on traffic and road conditions. We ensure a smooth, comfortable journey with scenic views along the way.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Ganpatipule route?',
            answer: 'Yes, our drivers are well-trained, experienced, and familiar with the best routes to Ganpatipule, ensuring a safe and pleasant ride.',
        },
        {
            question: 'Can I book a cab for sightseeing around Ganpatipule?',
            answer: 'Yes, Mauli Cabs offers customized sightseeing tours around Ganpatipule. Whether you want to visit the Ganapati Temple, explore nearby beaches, or enjoy nature, our drivers will guide you to the best spots.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are fully air-conditioned and well-maintained for comfort and cleanliness. We ensure a pleasant and hygienic ride to Ganpatipule.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. We offer a flexible cancellation policy through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Ganpatipule trip?',
            answer: 'Mauli Cabs offers competitive pricing, a range of vehicle options, professional drivers, and timely service. Whether for a relaxing beach vacation or a spiritual journey, we ensure a comfortable and hassle-free trip to Ganpatipule.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Sunil Deshmukh",
            position: "Beach Lover",
            text: "Our trip to Ganpatipule was amazing! The ride was comfortable, and the driver was very professional. We had a fantastic time at the beach, thanks to Mauli Cabs for a smooth ride and timely service.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Neha Yadav",
            position: "Family Traveler",
            text: "The journey to Ganpatipule was great. The driver was very polite and friendly, and the car was clean and well-maintained. We enjoyed our trip immensely and will definitely choose Mauli Cabs again for future travels.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Ganpatipule Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers affordable and reliable cab services from Pune to Ganpatipule. Book private, luxury, or group taxis for one-way or round-trip travel. Comfortable rides for beach trips, sightseeing, or family getaways with 24x7 online booking.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "3900"
        }
      };
      
      


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Ganpatipule Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Ganpatipule cab with Mauli Cabs. Affordable, comfortable taxi options for private, luxury, or group travel. One-way and round-trip bookings available 24x7 online."
        />
        <meta
          name="keywords"
          content="Pune to Ganpatipule cab service, Book Pune to Ganpatipule taxi, Affordable Pune to Ganpatipule cab, Private taxi for Ganpatipule from Pune, Ganpatipule trip by cab from Pune, Pune to Ganpatipule one-way or round trip, Ganpatipule sightseeing by cab, Group travel to Ganpatipule from Pune, Comfortable taxi ride to Ganpatipule, Luxury cab for Ganpatipule trip"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoganpatipule;